export default __webpack_public_path__ + "static/media/logoFbhLeanRes.03ccf3a8.png";